export default function deleteOrganizationReducer
    (state = { error:null, success:null, processing:false }, action) {

    switch (action.type)
    {
        case 'DELETE_ORGANIZATION_SUCCESS':
            return {...state, ...{success: action.success }};

        case 'DELETE_ORGANIZATION_ERROR':
            return {...state, ...{ error: action.error }};

        case 'DELETE_ORGANIZATION_PROCESSING':
            return {...state, ...{ processing: action.processing }};

        default: return state;
    }
}